import { Container, Spinner as ChackraSpinner } from "@chakra-ui/react";

export const Spinner = () => (
  <Container centerContent>
    <ChackraSpinner color="pink.500" data-testid="spinner" />
  </Container>
);
